export default __webpack_public_path__ + "static/media/47.8cd7d7b6.jpg";